'use client';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import { Skeleton } from '@/components/ui/skeleton';
import useIsMobile from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import GalleryItem from '../Gallery/item';
import classes from './crystalSatinVsSatinCharmeuseComparison.module.css';
import { useGetCategories } from './use-get-categories';
import { useGetFabric } from './use-get-fabric';

const CrystalSatinVsSatinCharmeuseComparison = () => {
  const { crystalSatinItems, loading, satinCharmeuseItems } = useGetFabric();

  const { products: swatchesProducts, loading: swatchesLoading } = useGetCategories({
    currentPage: 1,
    id: 'NDM=',
    filters: {
      aw_general_fabric: {
        eq: '9306',
      },
      category_uid: {
        eq: 'NDM=',
      },
    },
    pageSize: 8,
    sort: {
      position: 'ASC',
    },
    filter_color: '',
  });

  const { products: swatchesProducts2, loading: swatchesLoading2 } = useGetCategories({
    currentPage: 1,
    id: 'NDM=',
    filters: {
      aw_general_fabric: {
        eq: '8871',
      },
      category_uid: {
        eq: 'NDM=',
      },
    },
    pageSize: 36,
    sort: {
      position: 'ASC',
    },
    filter_color: '',
  });

  const headerClasses = 'font-Shango text-[22px] text-primary leading-[32px] border-b-1 border-solid border-[#E7DED5]';

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>Crystal Satin VS Satin Charmeuse </h2>
      <div className={classes.block}>
        <div className='relative h-[345px] w-[calc(100%-38px)] rounded-lg bg-[#f8f3ef] lg_h-[802px] lg_w-[550px]'>
          <Image
            src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/fabrics/crystal-satin-vs-satin-charmeuse-comparison/fabric-1.png`}
            alt='crystal-satin-vs-satin'
            width={568}
            height={800}
            className='absolute left-[38px] top-[41px] h-[410px] w-full rounded-lg lg_left-[82px] lg_top-[77px] lg_h-full'
          />
        </div>
        <div className='mt-[61px] flex flex-col justify-center lg_mt-0'>
          <h3 className={classes.contentTitle}>
            <span>Fabric: Crystal Satin</span>
          </h3>
          <div className={classes.contentSubTitle}>Features</div>
          <div className={classes.iconsContainer1}>
            <div className={classes.feature}>
              <p>Strong</p>
              <p>Luster</p>
            </div>
            <div className={classes.feature}>
              <p>Durable</p>
            </div>
            <div className={classes.feature}>
              <p>Beautiful</p>
              <p>Drape</p>
            </div>
          </div>
        </div>
      </div>
      <h1 className={cn(headerClasses, 'lg_mt-[7rem]')}>Featured Products</h1>
      <CarouselWrapper
        items={crystalSatinItems}
        loading={loading}
      />

      <h1 className={headerClasses}>Shop Swatches & Fabric</h1>
      <CarouselWrapper
        items={swatchesProducts?.items}
        loading={swatchesLoading}
      />

      <div className='flex flex-col-reverse justify-between lg_flex-row'>
        <div className='mt-[80px] flex flex-col justify-center lg_mt-0'>
          <h3 className={classes.contentTitle}>
            <span>Fabric: Satin Charmeuse</span>
          </h3>
          <div className={classes.contentSubTitle}>Features</div>
          <div className={classes.iconsContainer2}>
            <div className={classes.feature}>
              <p>Relatively</p>
              <p>Subtle Sheen</p>
            </div>
            <div className={classes.feature}>
              <p>Silky</p>
            </div>
            <div className={classes.feature}>
              <p>Soft</p>
            </div>
          </div>
        </div>
        <div className='relative h-[345px] w-full rounded-lg bg-[#f8f3ef] lg_h-[802px] lg_w-[550px]'>
          <Image
            src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/fabrics/crystal-satin-vs-satin-charmeuse-comparison/fabric-2.png`}
            alt='crystal-satin-vs-satin'
            width={568}
            height={800}
            className='absolute left-0 top-[-20px] h-[412px] w-[281px] rounded-lg lg_left-[-78px] lg_top-[83px]  lg_h-full lg_w-full'
          />
        </div>
      </div>

      <h1 className={cn(headerClasses, 'lg_mt-[7rem]')}>Featured Products</h1>
      <CarouselWrapper
        items={satinCharmeuseItems}
        loading={loading}
      />

      <h1 className={headerClasses}>Shop Swatches & Fabric</h1>
      <CarouselWrapper
        items={swatchesProducts2?.items}
        loading={swatchesLoading2}
      />
    </div>
  );
};

const CarouselWrapper = ({ items, loading }) => {
  const isMobile = useIsMobile();

  if (loading) {
    return (
      <div className='mb-[50px] mt-8 flex w-full space-x-4'>
        {[...Array(isMobile ? 2 : 6)].map((_, index) => (
          <Skeleton
            key={index}
            className={`${isMobile ? 'w-[calc(50%-0.5rem)]' : 'w-[calc(16.666%-1rem)]'} h-[200px] rounded-md`}
          />
        ))}
      </div>
    );
  }

  return (
    <Carousel className='mb-[50px] mt-8 w-full'>
      <CarouselContent>
        {items.map(item => (
          <CarouselItem
            key={item.id}
            className='flex basis-1/2 justify-center lg_basis-1/6'
          >
            <GalleryItem item={item} />
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className='hidden lg_block' />
      <CarouselNext className='hidden lg_block' />
    </Carousel>
  );
};

export default CrystalSatinVsSatinCharmeuseComparison;
